import {
  Box,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  CircularProgress,
} from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import { useQuery, useMutation } from "@apollo/client";
import {
  CREATE_RIGHT,
  UPDATE_RIGHT,
  ALL_MODULES,
} from "../../../data/RoleManagementData"; // Import your GraphQL queries and mutations
import swal from "sweetalert";
import { useState, useEffect } from "react";
import Header from "../../../components/Header";
import {
  generateAndExecuteMutation,
  graphqlQuery,
} from "../../../data/Axios/DynamicService";
import { allCompanies } from "../../../data/Axios/queries";
import { setupManagementUrl } from "../../../config";
import { executeDynamicSubmit, fetchJsonDynamic } from "../../../data/DynamicServiceNew/jsondynamicservice";
import Swal from "sweetalert2";

const setup_url = setupManagementUrl.uri;

const BanksForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const [industryTypes, setIndustryTypes] = useState([]);

  const initialValues = {
    bankName: props.data ? props.data.BankName : "",
    bankSwiftCode: props.data ? props.data.BankSwiftCode : "",
    finCode: props.data ? props.data.FinCode : "",
    mobile:  props.data ? props.data.Mobile : "",
    email: props.data ? props.data.Email : "",
    charLimit: props.data ? props.data.CharLimit : "",
  };

  const validationSchema = yup.object().shape({
    bankName: yup.string().required("Bank Name required"),
    charLimit: yup.string().required("Character Limit required"),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    const variables = props.isEditing
      ? { id: props.data.Id, ...values }
      : values;

    await executeDynamicSubmit({
      mutationName: props.isEditing ? "updateBanks" : "createBanks",
      variables,
      mutationObjectName: "result",
      baseUrl: setup_url,
      isEditing: props.isEditing,
      entityName: "Bank",
      onSuccess: () => {
        props.onClose();
        props.onAction();
      },
      setSubmitting,
    });
  };

  return (
    <Box m="20px">
      <Header
        title={props.isEditing ? "Edit Banks" : "Create Banks"}
        subtitle={
          props.isEditing
            ? "Edit an Existing Bank"
            : "Create a New Bank"
        }
      />

      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box display="grid" gap="30px">
                 <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Bank Name*"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.bankName}
                name="bankName"
                error={touched.bankName && !!errors.bankName}
                helperText={touched.bankName && errors.bankName}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Bank Swift Code*"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.bankSwiftCode}
                name="bankSwiftCode"
                error={touched.bankSwiftCode && !!errors.bankSwiftCode}
                helperText={touched.bankSwiftCode && errors.bankSwiftCode}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Fin Code*"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.finCode}
                name="finCode"
                error={touched.finCode && !!errors.finCode}
                helperText={touched.finCode && errors.finCode}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Mobile*"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.mobile}
                name="mobile"
                error={touched.mobile && !!errors.mobile}
                helperText={touched.mobile && errors.mobile}
                sx={{ gridColumn: "span 1" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="email"
                label="Email*"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.email}
                name="email"
                error={touched.email && !!errors.email}
                helperText={touched.email && errors.email}
                sx={{ gridColumn: "span 1" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="number"
                label="Character Limit*"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.charLimit}
                name="charLimit"
                error={touched.charLimit && !!errors.charLimit}
                helperText={touched.charLimit && errors.charLimit}
                sx={{ gridColumn: "span 1" }}
              />
              

            </Box>
            <Box display="flex" justifyContent="end" mt="20px">
              <Button
                type="submit"
                color="primary"
                variant="contained"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default BanksForm;
